"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInscription = void 0;
const jsontokens_1 = require("jsontokens");
const provider_1 = require("../provider");
const utils_1 = require("./utils");
const createInscription = async (options) => {
    const { getProvider } = options;
    const provider = await (0, provider_1.getProviderOrThrow)(getProvider);
    (0, utils_1.validateInscriptionPayload)(options.payload);
    try {
        const request = (0, jsontokens_1.createUnsecuredToken)(options.payload);
        const response = await provider.createInscription(request);
        options.onFinish?.(response);
    }
    catch (error) {
        console.error('[Connect] Error during create inscription', error);
        options.onCancel?.();
    }
};
exports.createInscription = createInscription;
